import { render } from "./TheGlobalNav.vue?vue&type=template&id=aa3cd184&scoped=true&ts=true"
import script from "./TheGlobalNav.vue?vue&type=script&lang=ts"
export * from "./TheGlobalNav.vue?vue&type=script&lang=ts"

import "./TheGlobalNav.vue?vue&type=style&index=0&id=aa3cd184&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa3cd184"]])

export default __exports__